
import './index.scss';
import LabeledInput from '../labeled-input';
import PropTypes from 'prop-types';
import React from 'react';

const handleNumberChange = ( props, name ) => event => {

    props.onChange( props, name, event.target.value );

};

const LabeledNumberRange = props => (

    <div>
        <div className="inner-rows">
            <LabeledInput
                className={props.className}
                name="fromNumb"
                isEditable={true}
                label="From"
                maxLength={15}
                value={props.from}
                onChange={handleNumberChange( props, 'from' )}
            />
        </div>
        <div className="inner-rows">
            <LabeledInput
                className={props.className}
                name="toNumb"
                isEditable={true}
                label="To"
                maxLength={15}
                value={props.to}
                onChange={handleNumberChange( props, 'to' )}
            />
        </div>
    </div>

);
LabeledNumberRange.displayName = 'LabeledNumberRange';
LabeledNumberRange.propTypes = {
    name: PropTypes.string.isRequired,
    from: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};
export default LabeledNumberRange;
